module.exports = __webpack_public_path__ + "static/media/credit-card-front.98c18eb7.svg";